module.exports = __webpack_public_path__ + "img/ico_arrow_down.70cc9008.svg";